export default __webpack_public_path__ + "static/media/LOGO-DUGAY.25726125.svg";